import { Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { ConnectionsScreen } from './screens/Connections'

/**
 * Connections route — mounted inside album/routes.tsx's `AlbumDesignRoot`,
 * reusing the same app shell as /albums, /galleries, /notification, and
 * /settings. Takes over the `/connections` path from the legacy
 * DashboardLayout page.
 *
 * /connections
 */
export const connectionsRouteElements = (
  <Route path='connections' element={<AlbumShellLayout />}>
    <Route index element={<ConnectionsScreen />} />
  </Route>
)
